import {
	TOPIC_SETTINGS_ADD_TOPICS,
	TOPIC_SETTINGS_RESET_TOPICS
} from "../constants";

const initialState = {
	data: []
};

export const TopicsReducer = ( state = initialState, action ) => {
	switch ( action.type ) {
		case TOPIC_SETTINGS_ADD_TOPICS :
			state = {
				...state,
				data: action.payload.data.topics
			};

			break;
		case TOPIC_SETTINGS_RESET_TOPICS :
			state = {
				...state,
				data: []
			};
			break;
	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/topics.js